import React from 'react';
import {
  cleanWhite,
  daveGrey,
  jetBlack,
  white,
} from '@shipae/components-sandbox/component/colors';
import styled, { css } from 'styled-components';
import SmartLink from 'components/smart-link';
import { media } from 'src/views/theme';

const Main = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  ${ media.sm } {
    margin-bottom: 6rem;
  }
`;

const PageNumberCss = css`
  &, &:active, &:visited {
    text-decoration: none;
    display: block;

    width: 4rem;
    height: 4rem;
    text-align: center;
    line-height: 4rem;
    border-radius: 50%;

    border: 1px solid;

    &:not(:last-child) {
      margin-right: 2rem;
    }
  }
`;

const PageNumberSpan = styled.span`
  ${ PageNumberCss }
  color: ${ cleanWhite() };
  background-color: ${ jetBlack() };
  border-color: 'transparent';
  &, &:active, &:visited {
    color: ${ white() };
  }
`;

const PageNumberLink = styled(SmartLink)`
  ${ PageNumberCss }
  color: ${ jetBlack() };
  background-color: ${ cleanWhite() };
  border-color: ${ daveGrey() };
`;

type Props = {
  totalPages: number;
  currentPage: number;
  subPath: string;
}

const Pagination: React.FC<Props> = ({
  totalPages,
  currentPage,
  subPath,
}) => (
  totalPages < 2 ? null : (
    <Main data-test="pagination-main">
      {[...Array(totalPages).keys()].map((_, index) => {
        const isCurrentPage = index + 1 === currentPage;
        const firstPage = index + 1 === 1;
        const to = firstPage ? subPath : `${ subPath }/page/${ index + 1 }`;

        return (
          isCurrentPage ? (
            <PageNumberSpan
              data-test="pagination-page-number"
              key={to}
            >
              {index + 1}
            </PageNumberSpan>
          ) : (
            <PageNumberLink
              href={to}
              dataTest="pagination-page-number"
              key={to}
            >
              {index + 1}
            </PageNumberLink>
          )
        );
      })}
    </Main>
  )
);

export default Pagination;
